(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceVenduDetailController', ServiceVenduDetailController);

    ServiceVenduDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ServiceVendu','Agence', 'TypeService', 'ModeleContrat','DTOptionsBuilder', 'DTColumnDefBuilder', '$translate'];

    function ServiceVenduDetailController($scope, $rootScope, $stateParams, entity, ServiceVendu, Agence, TypeService, ModeleContrat,DTOptionsBuilder, DTColumnDefBuilder, $translate) {
        var vm = this;
        vm.serviceVendu = entity;
        vm.historyRows = buildHistoryRows(entity);
        
        vm.load = function (id) {
            ServiceVendu.get({id: id}, function(result) {
                vm.serviceVendu = result;
                vm.historyRows = buildHistoryRows(result);
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:serviceVenduUpdate', function(event, result) {
            vm.serviceVendu = result;
            vm.historyRows = buildHistoryRows(result);
        });
        $scope.$on('$destroy', unsubscribe);

        
        vm.standardOptions = DTOptionsBuilder
        .newOptions()
         //Add Bootstrap compatibility
        .withDOM("<'dt-toolbar'<'col-xs-12 col-sm-6'f><'col-sm-6 col-xs-12 hidden-xs'l>r>" +
            "t" +
            "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'p>>")
        .withBootstrap();
        
	    vm.standardColumns = [
	        DTColumnDefBuilder.newColumnDef(0),
	        DTColumnDefBuilder.newColumnDef(1),
	        DTColumnDefBuilder.newColumnDef(2),
	        DTColumnDefBuilder.newColumnDef(3)
	    ];

        /**
         * L'historique contient l'état précédant chaque modification. L'état qui
         * suit est donc l'état actuel pour la ligne la plus récente, puis l'état
         * précédent de la ligne plus récente pour les autres lignes.
         */
        function buildHistoryRows(serviceVendu) {
            var histories = angular.copy(serviceVendu.historiqueCoutContrats || []);
            var fields = [
                {name: 'unitPrice', labelKey: 'wamasysApp.serviceVendu.unitPrice'},
                {name: 'amountPerInstallment', labelKey: 'wamasysApp.serviceVendu.amountPerInstallment'},
                {name: 'totalCredit', labelKey: 'wamasysApp.serviceVendu.totalCredit'},
                {name: 'frequency', labelKey: 'wamasysApp.serviceVendu.frequency'},
                {name: 'intervalType', labelKey: 'wamasysApp.serviceVendu.intervalTypeLabel'},
                {name: 'typeTax', labelKey: 'wamasysApp.serviceVendu.typeTax'}
            ];

            histories.sort(function(left, right) {
                var dateComparison = new Date(right.dateCreation).getTime() - new Date(left.dateCreation).getTime();
                return dateComparison !== 0 ? dateComparison : (right.id || 0) - (left.id || 0);
            });

            return histories.map(function(history, index) {
                var newValues = index === 0 ? serviceVendu : histories[index - 1];
                var changes = [];

                angular.forEach(fields, function(field) {
                    var oldValue = history[field.name];
                    var newValue = newValues[field.name];
                    if (!sameHistoryValue(field.name, oldValue, newValue)) {
                        changes.push({
                            labelKey: field.labelKey,
                            oldValue: formatHistoryValue(field.name, oldValue),
                            newValue: formatHistoryValue(field.name, newValue)
                        });
                    }
                });

                return {
                    id: history.id,
                    dateCreation: history.dateCreation,
                    createdBy: history.createdBy,
                    commentaire: history.commentaire,
                    changes: changes
                };
            });
        }

        function sameHistoryValue(fieldName, oldValue, newValue) {
            if (fieldName === 'typeTax') {
                return taxIdentifier(oldValue) === taxIdentifier(newValue);
            }
            return oldValue === newValue;
        }

        function taxIdentifier(typeTax) {
            if (!typeTax) {
                return null;
            }
            return angular.isDefined(typeTax.id) ? typeTax.id : typeTax.label + '|' + typeTax.taxRate;
        }

        function formatHistoryValue(fieldName, value) {
            if (value === null || angular.isUndefined(value)) {
                return null;
            }
            if (fieldName === 'typeTax') {
                return value.label + ' (' + value.taxRate + ' %)';
            }
            if (fieldName === 'intervalType') {
                return $translate.instant('wamasysApp.serviceVendu.intervalType.' + value);
            }
            return value;
        }
    
    }
})();
